export enum TicketActionTypes {
    SET_TICKETS = 'tickets/setTickets',
    LOADING_TICKETS = 'tickets/loadingTickets'
}